module.exports = __webpack_public_path__ + "img/NovembroAzul-Banner-1080x200.936302c0.jpg";